(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('ChangeMetisCompabilityController', ChangeMetisCompatibilityController);

    ChangeMetisCompatibilityController.$inject = ['$scope', '$uibModalInstance', 'entity', 'AlertService', 'PlanningEventsService', 'EventsService',
        'parameters', '$rootScope', 'Principal', 'SoopkitchenUtils', '$cookies', '$timeout', '$uibModal', '$controller', '$sce'];

    function ChangeMetisCompatibilityController
        ($scope, $uibModalInstance, entity, AlertService, PlanningEventsService, EventsService, parameters,
            $rootScope, Principal, SoopkitchenUtils, $cookies, $timeout, $uibModal,$controller,$sce) {
            var vm = this;
            vm.isEditable = false;
            vm.selectedMetisCompability = "YES";
            vm.blinkingTimeout = 2000;
            vm.isValidDate = SoopkitchenUtils.isValidDate;
            vm.nameEventMap = {};
            vm.nameAllEventsMap = {};
            vm.attributeClassMap = {};
            vm.plan = entity;
            vm.schema = entity.schema;
            vm.startTime = parameters.startTime;
            vm.endTime = parameters.endTime;

            // vm.selectedEvent = vm.nameEventMap['POINT_FEATURE'];
            var title = 'Change Metis compatibility to all POINT events in an interval into Plan <span class="label label-info">'+entity.label+'</span>, Version <span\n' +
                'class="label label-info">'+entity.internalVersion+'</span>';
            angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
            // vm.headerTitle = ";
            vm.cancelText = "Cancel";
            vm.saveText= "Apply";
            vm.deleteText='None';
            vm.save = changeMetisCompatibility;
            vm.clear = clear;
            vm.planLabel =  entity.label;
            vm.planType =  parameters.planType;
            function clear() {
                $uibModalInstance.dismiss('cancel');
            }
            function successCallback(response) {
                var msg = "POINT Events in the interval ("+vm.startTime + " - " + vm.endTime + ") have been updated its METIS compatibility to " + vm.selectedMetisCompability;
                SoopkitchenUtils.processResponse(
                            response,
                            "Changed METIS compatibility",
                            msg,
                            vm.clear
                        );
                SoopkitchenUtils.updatePlanFromDialog(response.data);
            }
            function changeMetisCompatibility() {
                EventsService.updateMetisCompatibility(vm.planType, vm.planLabel , vm.startTime , vm.endTime, vm.selectedMetisCompability, successCallback);
            }
        }
    })();
